var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.399,
    height: 145.585,
    viewBox: "0 0 102.399 145.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.194,
    x2: 0.5,
    y2: -0.126,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e42f18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e2122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e21518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f9ba1a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M15.75,97.77C15.27,87.16,19.67,79,25.17,70.51c6.64-10.22,12.29-18.92.57-34,2.45,10.69-3,17.63-9.12,25.54-12,15.44-19,32.18-10.79,51.4,6.57,15.4,21,25.12,37,28.79-.57-18.46,7.5-27.18,14.69-34.92,8.16-8.8,15.76-18,5.23-36.8,10.36,13.61,10.37,23.31-3.57,38.34-11,11.83-14.85,19.52-13.94,36.2-18-3.73-34-13.21-41.46-30.72-8.54-20-1.45-37.56,11.1-53.68C26.28,46,26.24,42.1,19.14,25.76c16.17,17.44,21.79,24.66,7.93,46-5.24,8.07-9.51,15.82-9,25.94.42,9.43,5.69,20.09,23,28.36-13.32-3.39-24.59-13.8-25.25-28.27Zm18.12-1.13c.23,3.7,1.54,11.69,11.88,16.41a21.12,21.12,0,0,1-9.62-16.54c-1.07-17.28,18.62-37.11,20.21-63C57.35,17.22,53,7.59,39.07,0c3.9,12.39,1.86,29.12-5.9,39.81.42.71.83,1.43,1.2,2.16,7.23-9.24,10.48-25.92,8.37-37.28,10.35,6.75,12,17.43,11.34,28.72-1.6,26-21.35,44.75-20.21,63.23ZM69.3,46.38c-5-7.17-8.44-12.14-7.55-16.77C59,35.35,63,41.19,67.47,47.59c2.59,3.75,5.34,7.7,6.77,11.81A17.449,17.449,0,0,1,76,57.68c-1.6-4-4.19-7.74-6.66-11.3ZM67.41,56.56c-4-6.49-6-9.19-5.7-13.28-1.92,5.16.75,9.47,3.8,14.39A37.62,37.62,0,0,1,71,70.46,20.75,20.75,0,0,1,71.48,64a56,56,0,0,0-4.07-7.41Zm4.85,43.94C66,116.78,49,122.87,51.93,145.55c26.49.93,48-17,50.28-43.46,1.15-13.48-2.09-28.67-8.61-43.13A115.45,115.45,0,0,0,64,19.08c-3.45,10.56,6.46,17.7,12.08,26.8C83,57.1,87.94,70.09,89.1,82.57a53.309,53.309,0,0,1,2.43,9.05c.92-15.51-4.71-32.45-13.34-46.54-3.52-5.75-13.28-16.14-12.85-21.89A113.94,113.94,0,0,1,91.55,59.78c6.35,14.1,9.52,28.89,8.4,42a45,45,0,0,1-46,41.58c-2.17-18.93,14.05-27,18.33-42.84ZM88,105.25c5.86-9.63-2.13-25.82-3.85-30-3-7.25-4.61-10.84-4-18.51-9.38,5.9-7.89,11.47-5.92,22,1.84,9.79,4.07,21.75-4.36,33.87,12.29-7.58,7.39-29.88,6.59-34.14C75.12,71.2,74,65.17,77.71,61.34,78,66,79.94,70.74,82.09,76,85.4,84,89.22,93.36,88,105.25Z",
    transform: "translate(-0.039)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.b32015572e397c17df342f1e50064c26.svg";
export { ForwardRef as ReactComponent };